import Auth from 'live/services/authorization'

export function canManageAssetSetup(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.ASSET_SETUP_ADMIN
}

export function canViewAssetSetup(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.ASSET_SETUP_VIEW || Auth.Permission.ASSET_SETUP_ADMIN
}